import React from 'react';
import PropTypes from 'prop-types';

// Import styles
import { Loader, StyledAnchor, StyledButton, StyledLink } from './styles';

// Import helpers
import { getSizeValue } from './helpers';

// Import variables
import { TV_PATHS } from 'components/routes/tv_routes/paths';

const { MAIN } = TV_PATHS;

const ProfileButton = ({
	text,
	paddingX,
	paddingY,
	margin,
	width,
	height,
	as,
	isLoading,
	disabled,
	size,
	theme,
	onClick,
	to,
	children
}) => {
	const fontSize = getSizeValue(size);
	const styles = { width, height, paddingX, paddingY, size, margin };
	switch (as) {
		case 'button':
			return (
				<StyledButton
					onClick={onClick}
					disabled={disabled}
					themes={theme}
					styles={styles}
				>
					{isLoading && <Loader size={fontSize} type="loading" />}
					{children ?? text}
				</StyledButton>
			);
		case 'link':
			const path = to?.path ?? to ?? MAIN;
			return (
				<StyledLink
					to={path}
					disabled={disabled}
					isLoading={isLoading}
					themes={theme}
					styles={styles}
				>
					{children ?? text}
				</StyledLink>
			);
		case 'external':
			const href = to?.path ?? to ?? '/';
			const target = to?.target ?? '_blank';
			return (
				<StyledAnchor
					href={href}
					target={target}
					rel="nofollow noopener noreferrer"
					disabled={disabled}
					themes={theme}
					styles={styles}
				>
					{children ?? text}
				</StyledAnchor>
			);
		default:
			return null;
	}
};

ProfileButton.defaultProps = {
	text: '',
	paddingX: '3rem',
	paddingY: '1.3rem',
	margin: '0rem',
	as: 'button',
	isLoading: false,
	disabled: false,
	size: 'normal',
	theme: 'primary',
	onClick: () => {},
	width: 'auto',
	height: 'auto',
	to: null
};

ProfileButton.propTypes = {
	text: PropTypes.string.isRequired,
	paddingX: PropTypes.string,
	paddingY: PropTypes.string,
	margin: PropTypes.string,
	as: PropTypes.oneOf(['button', 'link', 'external']),
	isLoading: PropTypes.bool,
	disabled: PropTypes.bool,
	size: PropTypes.oneOf(['normal', 'xs', 'xl']),
	theme: PropTypes.oneOf(['primary', 'reject']),
	onClick: PropTypes.func,
	width: PropTypes.string,
	height: PropTypes.string,
	to: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.shape({
			path: PropTypes.string,
			target: PropTypes.string
		})
	])
};

export default ProfileButton;
